<div
  class="form-select"
  (clickElsewhere)="closeTooltip()"
  [class.disabled]="isDisabled"
  [class.offsetRightArrow]="isVerification"
  [class.employerStage]="employerStage"
  [attr.data-cy]="dataCyName"
>
  @if (label || message) {
    <div class="form-select__header level">
      <div class="level-left" (click)="closeTooltip()">
        <label class="form-select__label is-small">
          <span
            class="form-select__label-tx"
            [innerHTML]="label | translate: { year: statement?.fullYear || '' }"
          ></span>
        </label>
      </div>
      <!-- <div class="level-right tooltip-ico" *ngIf="message" (click)="toggleTooltip()">
      <span class="more-info__ico info-ico is-unselectable">i</span>
    </div> -->
      @if (message) {
        <app-more-info-tooltip
          class="tooltipInInput"
          [message]="message"
          [isSmall]="true"
          [showText]="false"
          [isSmallIcon]="true"
          [additionalDeductions]="true"
          [tooltipInInput]="true"
        ></app-more-info-tooltip>
      }
    </div>
  }
  <mat-select
    [panelClass]="disableOptionCentering ? 'customPanelClass' : ''"
    class="mat-select-white"
    [placeholder]="placeholder | translate"
    [(ngModel)]="model"
    (openedChange)="onFocus($event)"
    (selectionChange)="change($event)"
    [class.form-select--error]="errors"
    [disabled]="isDisabled"
    id="{{ currentName + '_' + currentIndex.toString() }}"
    [ngClass]="addClassB2B ? classB2B : ''"
    required
    [attr.autofocus]="autofocus ? autofocus : null"
  >
    @for (choice of choices; track trackBy(i, choice); let i = $index) {
      <mat-option
        class="{{ currentName + '_' + currentIndex + '_option_' + i }} mat-option"
        [value]="valueName != null ? choice[valueName] : choice"
      >
        @if (translateChoices) {
          <span>{{ (optionName != null ? choice[optionName] : choice) | translate }}</span>
        }
        @if (!translateChoices) {
          <span>{{ optionName != null ? choice[optionName] : choice }}</span>
        }
      </mat-option>
    }
  </mat-select>
  <!-- <div class="tooltip-container top" *ngIf="displayTooltip && message" role="tooltip">
<div class="tooltip-container__close">
  <span class="fa fa-times-circle" (click)="closeTooltip()"></span>
</div>taxClass ng-star-inserted
<div class="tooltip-container__text">{{ message | translate }}</div>
</div> -->
  @if (errors && shouldRenderErrors) {
    <div class="form-select__error">{{ errors[0] }} </div>
  }
</div>
